export const getAlternativePrice = (context: any) => {
  try {
    const now = new Date()
    const stringAlternativePrices =
      context?.$shopConfig?.webConfig?.alternativePrice ?? null
    const parsedAlternativePrices = stringAlternativePrices
      ? JSON.parse(stringAlternativePrices)
      : null
    if (!parsedAlternativePrices) {
      return null
    }
    const currentAlternativePrice = parsedAlternativePrices.find(
      (price: any) =>
        new Date(price?.validFrom) <= now && new Date(price?.validTo) >= now
    )
    return currentAlternativePrice ?? null
  } catch (e) {
    console.error('Alternative price load failed', e)
    return null
  }
}
